import React, { Component, PropTypes } from 'react';
import ColoredLabel from '../common/components/ColoredLabel';
import { Tip } from 'react-fast-ui';

export default class TourneyLabel extends Component {
  static propTypes = {
    tipPlacement: PropTypes.oneOf([ 'left', 'top', 'bottom', 'right' ]),
    tourney: PropTypes.shape({
      acronym: PropTypes.string.isRequired,
      color: PropTypes.string,
      name: PropTypes.string.isRequired
    })
  };

  static defaultProps = {
    tipPlacement: 'top'
  };

  render() {
    const { tipPlacement, tourney } = this.props;
    const { acronym, color } = tourney;
    const name = tourney.name;

    return (
      <Tip tip={name} placement={tipPlacement}>
        <ColoredLabel color={color}>{acronym}</ColoredLabel>
      </Tip>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/TourneyLabel.jsx